var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStorage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.876,
    height: 28.781,
    viewBox: "0 0 26.876 28.781",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Storage",
    transform: "translate(0.1 0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_988",
    "data-name": "Path 988",
    d: "M8.429,57H7.476a.476.476,0,0,0,0,.953h.953a.476.476,0,1,0,0-.953Z",
    transform: "translate(-5.571 -30.801)",
    fill: "#44677b",
    stroke: "#44677b",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_989",
    "data-name": "Path 989",
    d: "M8.429,54H7.476a.476.476,0,0,0,0,.953h.953a.476.476,0,1,0,0-.953Z",
    transform: "translate(-5.571 -29.23)",
    fill: "#44677b",
    stroke: "#44677b",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_990",
    "data-name": "Path 990",
    d: "M26.429,57h-.953a.476.476,0,1,0,0,.953h.953a.476.476,0,0,0,0-.953Z",
    transform: "translate(-14.997 -30.801)",
    fill: "#44677b",
    stroke: "#44677b",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_991",
    "data-name": "Path 991",
    d: "M26.429,54h-.953a.476.476,0,1,0,0,.953h.953a.476.476,0,0,0,0-.953Z",
    transform: "translate(-14.997 -29.23)",
    fill: "#44677b",
    stroke: "#44677b",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_992",
    "data-name": "Path 992",
    d: "M44.429,57h-.953a.476.476,0,0,0,0,.953h.953a.476.476,0,1,0,0-.953Z",
    transform: "translate(-24.422 -30.801)",
    fill: "#44677b",
    stroke: "#44677b",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_993",
    "data-name": "Path 993",
    d: "M44.429,54h-.953a.476.476,0,0,0,0,.953h.953a.476.476,0,1,0,0-.953Z",
    transform: "translate(-24.422 -29.23)",
    fill: "#44677b",
    stroke: "#44677b",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_994",
    "data-name": "Path 994",
    d: "M30.2,20.1H26.389V11.051a.476.476,0,0,0-.476-.476H22.1v-8.1A.476.476,0,0,0,21.625,2H13.051a.476.476,0,0,0-.476.476v8.1H8.764a.476.476,0,0,0-.476.476V20.1H4.476A.476.476,0,0,0,4,20.578V30.1a.476.476,0,0,0,.476.476H30.2a.476.476,0,0,0,.476-.476V20.578A.476.476,0,0,0,30.2,20.1Zm-4.764.953h.953V22.96h-.953Zm0-.953H17.814V11.527H20.2v2.382a.476.476,0,0,0,.476.476h1.905a.476.476,0,0,0,.476-.476V11.527h2.382Zm-8.574.953h.953V22.96h-.953Zm5.24-9.527v1.905h-.953V11.527ZM17.814,2.953v.953h-.953V2.953Zm-4.287,0h2.382V4.382a.476.476,0,0,0,.476.476h1.905a.476.476,0,0,0,.476-.476V2.953h2.382v7.622H13.527Zm0,8.574v1.905h-.953V11.527Zm-4.287,0h2.382v2.382a.476.476,0,0,0,.476.476H14a.476.476,0,0,0,.476-.476V11.527h2.382V20.1H9.24Zm0,9.527V22.96H8.287V21.054Zm-4.287,0H7.334v2.382a.476.476,0,0,0,.476.476H9.716a.476.476,0,0,0,.476-.476V21.054h2.382v8.574H4.953Zm8.574,0h2.382v2.382a.476.476,0,0,0,.476.476h1.905a.476.476,0,0,0,.476-.476V21.054h2.382v8.574H13.527Zm16.2,8.574H22.1V21.054h2.382v2.382a.476.476,0,0,0,.476.476h1.905a.476.476,0,0,0,.476-.476V21.054h2.382Z",
    transform: "translate(-4 -2)",
    fill: "#44677b",
    stroke: "#44677b",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_995",
    "data-name": "Path 995",
    d: "M16.476,37.953h.953a.476.476,0,1,0,0-.953h-.953a.476.476,0,1,0,0,.953Z",
    transform: "translate(-10.284 -20.328)",
    fill: "#44677b",
    stroke: "#44677b",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_996",
    "data-name": "Path 996",
    d: "M16.476,34.953h.953a.476.476,0,1,0,0-.953h-.953a.476.476,0,1,0,0,.953Z",
    transform: "translate(-10.284 -18.757)",
    fill: "#44677b",
    stroke: "#44677b",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_997",
    "data-name": "Path 997",
    d: "M35.429,37h-.953a.476.476,0,0,0,0,.953h.953a.476.476,0,1,0,0-.953Z",
    transform: "translate(-19.709 -20.328)",
    fill: "#44677b",
    stroke: "#44677b",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    "data-name": "Path 998",
    d: "M35.429,34h-.953a.476.476,0,0,0,0,.953h.953a.476.476,0,1,0,0-.953Z",
    transform: "translate(-19.709 -18.757)",
    fill: "#44677b",
    stroke: "#44677b",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_999",
    "data-name": "Path 999",
    d: "M25.476,14.953h.953a.476.476,0,0,0,0-.953h-.953a.476.476,0,1,0,0,.953Z",
    transform: "translate(-14.997 -8.284)",
    fill: "#44677b",
    stroke: "#44677b",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1000",
    "data-name": "Path 1000",
    d: "M25.476,17.953h.953a.476.476,0,0,0,0-.953h-.953a.476.476,0,1,0,0,.953Z",
    transform: "translate(-14.997 -9.855)",
    fill: "#44677b",
    stroke: "#44677b",
    strokeWidth: 0.2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorage);
export default __webpack_public_path__ + "static/media/storage.13f7682c78aaf5a3f89ba1369482aac7.svg";
export { ForwardRef as ReactComponent };